exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-9618e{border-radius:100%;height:4.4rem;margin:2.4rem 0 1.8rem 0;width:4.4rem}.text-e45e1{max-width:50.5rem}", ""]);

// Exports
exports.locals = {
	"icon": "icon-9618e",
	"text": "text-e45e1"
};